import React from 'react';
import CommonChart from '../CommonChart';
import { getCompetitorBatchTopicKeywordTimeLine } from '@/pages/opinion/services';

export default function KeywordChart({
  xAxisList,
  dau,
  commonParams,
  isNoMobile,
}: any) {
  return (
    <CommonChart
      xAxisList={xAxisList}
      dau={dau}
      commonParams={commonParams}
      isNoMobile={isNoMobile}
      requestFunc={getCompetitorBatchTopicKeywordTimeLine}
      selectTitle="Keywords"
      title="Keywords"
    ></CommonChart>
  );
}
